import { Component, OnInit } from '@angular/core';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { MatDialogRef } from '@angular/material';
import { UserService } from '../../../services/user.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FilterCompleteService } from 'src/app/filter-complete/filter-complete';
import { Scanner } from 'src/app/model/scanner';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-scanner-dialog',
  templateUrl: 'scanner-dialog.component.html',
})
export class ScannerDialogComponent implements OnInit {
  form: FormGroup;
  loading: boolean;
  loadingAction: boolean;
  filterCompleteScanner: FilterCompleteService<Scanner>;
  constructor(public dialogRef: MatDialogRef<ScannerDialogComponent>
    , private userService: UserService
    , private notificationToastService: NotificationToastService
    , private authService: AuthService
    , private formBuilder: FormBuilder
  ) {
    this.form = this.formBuilder.group({
      Scanner: ['', Validators.required]
    });

    this.filterCompleteScanner = new FilterCompleteService<Scanner>([], this.f.Scanner);
  }

  get filteredScannerOptions() { return this.filterCompleteScanner ? this.filterCompleteScanner.filteredOptions : []; }
  get f() { return this.form.controls; }

  async ngOnInit() {
    try {
      this.loading = true;
      const scanners = await this.userService.getScanners('');
      this.filterCompleteScanner = new FilterCompleteService<Scanner>(scanners, this.f.Scanner);
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Escáner');
    } finally {
      this.loading = false;
    }
  }

  onNoClick(): void {
      this.dialogRef.close(false);
  }

  async save() {
    try {
      if (!this.form.invalid) {
        this.loadingAction = true;
        const scanner = <Scanner>this.f.Scanner.value;
        if (await this.userService.scannerUserUpdate(this.authService.getUserId(), scanner.Id)) {
          this.authService.setUserScanner(scanner);
          this.dialogRef.close(scanner);
        }
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Escáner');
    } finally {
      this.loadingAction = false;
    }
  }
}
